import { GridCallout } from 'components/grid_callout'
import { MLPSection } from '../MLPSection'
import { MLPClubCalloutText } from './MLPClubCalloutText'
import { MLPClubCalloutImages } from './MLPClubCalloutImages'
import { useTheme } from '@fable/theme'
import { GridCalloutCard } from 'components/grid_callout/types'
import { clubCards } from './calloutCards'

interface Props {
  className?: string
  gridClassName?: string
  cards?: GridCalloutCard[]
  reverse?: boolean
  description?: string
}

export const MLPClubCallout = ({
  cards = clubCards,
  className,
  gridClassName,
  reverse = false,
  description,
}: Props) => {
  const { colors } = useTheme()

  return (
    <MLPSection id="clubs" className={className}>
      <GridCallout
        className={gridClassName}
        textContent={<MLPClubCalloutText description={description} />}
        imageContent={<MLPClubCalloutImages />}
        cards={cards}
        theme={{ light: colors.uiGreenUltraLight, dark: colors.uiGreen }}
        reverse={reverse}
      />
    </MLPSection>
  )
}
